import {ProductType} from '@/commons/enums/ProductType';

export const DealAvatars = {
  [ProductType.CASH]: require('@/assets/productTypesImg/avatarGotwoka.svg'),
  [ProductType.SME]: require('@/assets/productTypesImg/avatarFirmowy.svg'),
  [ProductType.MORTGAGE]: require('@/assets/productTypesImg/avatarHipoteka.svg'),
  [ProductType.REAL_ESTATE]: require('@/assets/productTypesImg/avatarNieruchomosc.svg'),
  [ProductType.INSURANCE]: require('@/assets/productTypesImg/avatarUbezpieczenia.svg'),
  [ProductType.NONBANK]: require('@/assets/bankLogotypes/PLACEHOLDER-circle.webp'),
  [ProductType.FACTORING]: require('@/assets/bankLogotypes/PLACEHOLDER-circle.webp'),
  [ProductType.INVESTMENT]: require('@/assets/bankLogotypes/PLACEHOLDER-circle.webp'),
  [ProductType.LEASING]: require('@/assets/bankLogotypes/PLACEHOLDER-circle.webp'),
};

export const DealIcons = {
  [ProductType.MORTGAGE]: require('@/assets/productIcons/productTypeMortgage.svg'),
  [ProductType.CASH]: require('@/assets/productIcons/productTypeCash.svg'),
  [ProductType.LEASING]: require('@/assets/productIcons/productTypeSmeLeasing.svg'),
  [ProductType.FACTORING]: require('@/assets/productIcons/productTypeSmeFactoring.svg'),
  [ProductType.REAL_ESTATE]: require('@/assets/productIcons/productTypeRealEstate.svg'),
  [ProductType.MEDICAL_INSURANCE]: require('@/assets/productIcons/productTypeInsuranceMedical.svg'),
  [ProductType.VEHICLE_INSURANCE]: require('@/assets/productIcons/productTypeInsuranceVehicle.svg'),
  [ProductType.ASSETS_INSURANCE]: require('@/assets/productIcons/productTypeInsuranceAssets.svg'),
  [ProductType.LIFE_INSURANCE]: require('@/assets/productIcons/productTypeInsuranceLife.svg'),
  [ProductType.INVESTMENT]: require('@/assets/productIcons/productTypeSme.svg'),
  [ProductType.NONBANK]: require('@/assets/productIcons/productTypeSme.svg'),
  [ProductType.SME]: require('@/assets/productIcons/productTypeSme.svg'),
  [ProductType.INSURANCE]: require('@/assets/productIcons/productTypeInsurance.svg'),
};
